export default __webpack_public_path__ + "static/media/nodejs-negative.f2720fc7.svg";